/* eslint-disable */
export default {
  noResultFoundFor: 'No result found for',
  search: 'Search',
} as const;

// @key: @#@"noResultFoundFor"@#@ @source: @#@"No result found for"@#@
// @key: @#@"search"@#@ @source: @#@"Search"@#@
